import React from 'react';
import Icon from '~/components/atom/Icon';
import { Container } from '../../styles';
import EdgeLabelWrapper from '../components/EdgeLabelWrapper';

const text = {
  insertAction: 'Actie(s) invoegen',
};

type Props = {
  midX: number;
  midY: number;
  testId: string;
  onInsertAction: () => void;
};

/**
 * The container that is shown when the user is pasting an action
 */
const InsertEdgeLabel: React.FCC<Props> = ({
  midX,
  midY,
  testId,
  onInsertAction,
}) => (
  <EdgeLabelWrapper midX={midX} midY={midY} interactive>
    <Container
      $variant="insert"
      $interactive
      onClick={onInsertAction}
      data-testid={testId}
    >
      <Icon name="clipboard" strokeWidth={3} />
      {text.insertAction}
    </Container>
  </EdgeLabelWrapper>
);

export default InsertEdgeLabel;
